<template>
  <ul :id="'qa_' + model.id" :class="{'list02-list': model.id === 0 }">
    <li 
      :class="{'list02-item': model.id != 0, 'is-selected': group1.isSelected, 'is-parent': group1.isFolder, 'is-open': group1.isFolder && group1.isOpen}">
      <div v-if="model.id !== 0" @click="group1.toggle" class="wrap">
        <div class="label" :role="group1.isFolder ? 'button' : ''">
          <template v-if="group1.isFolder">
            <FontawesomeIcon :icon="group1.isOpen ? 'minus' : 'plus'" class="icn-before" />
          </template>
          <!-- タイトル1行目 -->
          <span v-if="group1.isFolder" class="main content-title">{{ model.title_first_line }}</span>
          <a v-else @click.prevent.stop="group1.onQATitleClicked(model.id)" class="main content-title" role="button">{{ model.title_first_line }}</a>
          <!-- タイトル2行目以降 -->
          <template v-for="(line, index) in model.title_after_second_lines">
            <span :key="'second_line_' + index" class="indent content-title">{{ line }}</span>
          </template>
        </div>
      </div>
      <template v-if="(model.id === 0 || group1.isOpen) && group1.isFolder">
        <PCQADetailTableOfContentsTreeItem
          v-for="model2 in group1.children" :model="model2" :key="model2.node_id" 
          @emitTitleClicked="group1.emitTitleClicked"
        />
      </template>
    </li>
  </ul>
</template>

<script>
// QA詳細画面：目次ツリー生成用コンポーネント
import { ref, reactive, computed, watch, defineComponent, onMounted } from '@vue/composition-api'
import PCQADetailTableOfContentsTreeItem from '@/components/pc/partial/qa/PCQADetailTableOfContentsTreeItem'
import * as logicQADetailTableOfContentsTreeItem from '@/logic/qa/QADetailTableOfContentsTreeItem'

export default defineComponent({
  name: 'PCQADetailTableOfContentsTreeItem',
  components: {
    PCQADetailTableOfContentsTreeItem
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    onMounted(() => {
      group1.init()
    })

    const group1 = logicQADetailTableOfContentsTreeItem.getGroup(props, context)

    return {
      group1
    }
  }
})
</script>
<style lang="scss" scoped>
  @media print {
    .content-title {
      line-height: 1.5;
      font-weight: normal;
    }
  }
</style>
